import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import theme from '../../theme';

export const ModalPapper = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  minWidth: '300px',
  maxWidth: '800px',
  textAlign: 'center',
  backgroundColor: '#FFF',
  borderRadius: '10px',
  boxShadow: 24,
  transform: 'translate(-50%, -50%)',

  '&:focus-visible': {
    outline: 'none'
  }
})

export const TablePaper = styled(Box)({
  width: '100%',
  height: 'calc(100vh - 220px)',
  backgroundColor: '#fff',
  borderRadius: '4px',
  boxShadow: `0px 2px 6px ${theme.palette.grey.w300}`,
})

export const PopBox = styled(Box)({
  padding: '12px 0 12px',
  textAlign: 'center',
  backgroundColor: '#fff',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.grey.w100}`,
  boxShadow: `0px 2px 6px ${theme.palette.grey.w300}`
})